import {IronContextRegistry} from 'common/report/context-registry';

import {BehaviorsProvider} from './behaviors-context';
import {BookmarkProvider} from './bookmark-context';
import {CurrentProjectProvider} from './current-project-context';
import {CurrentUserProvider} from './current-user-context';
import {DashboardSelectorControllerProvider} from './dashboard-selector-controller-context';
import {DragAndDropManagerProvider} from './drag-and-drop-manager-context';
import {EventDefinitionsProvider} from './event-definitions-context';
import {GlobalSearchControllerProvider} from './global-search-controller-context';
import {HistoryManagerProvider} from './history-manager-context';
import {MetricsResourceProvider} from './metrics-resource-context';
import {HomePinnedCardProvider} from './pinned-card-context';
import {QueryContextManagerProvider} from './query-context-manager';
import {ReportEditorActionsProvider} from './report-editor-actions-context';
import {ReportLayoutManagerProvider} from './report-layout-manager-context';
import {SegmentFilterControllerProvider} from './segment-filter-controller-context';
import {LocalStorageManagerProvider, SessionStorageManagerProvider} from './storage-manager-context';
import {ProjectsProvider} from './projects-context';
import {ProjectTopCreatorsProvider} from './project-top-creators-context';
import {EventsControllerProvider} from './events-controller-context';

/**
 * Maps Panel context names to their respective React providers.
 */
export const PanelContextToReactProvider: Partial<
  Record<keyof IronContextRegistry, React.ComponentType<React.ProviderProps<any>>>
> = {
  behaviors: BehaviorsProvider,
  bookmarkStore: BookmarkProvider,
  currentProject: CurrentProjectProvider,
  currentUser: CurrentUserProvider,
  eventsController: EventsControllerProvider,
  dashboardSelectorController: DashboardSelectorControllerProvider,
  dragAndDropManager: DragAndDropManagerProvider,
  eventDefinitions: EventDefinitionsProvider,
  globalSearchController: GlobalSearchControllerProvider,
  historyManager: HistoryManagerProvider,
  metrics: MetricsResourceProvider,
  homePinnedCards: HomePinnedCardProvider,
  queryContextManager: QueryContextManagerProvider,
  reportEditorActions: ReportEditorActionsProvider,
  reportLayoutManager: ReportLayoutManagerProvider,
  segmentFilterController: SegmentFilterControllerProvider,
  localStorageManager: LocalStorageManagerProvider,
  sessionStorageManager: SessionStorageManagerProvider,
  projects: ProjectsProvider,
  projectTopCreators: ProjectTopCreatorsProvider,
};
